module.exports = __webpack_public_path__ + "img/law2.4ec5a139.jpg";